/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type CartItem_user$ref = any;
export type CartItems_user$ref = any;
export type CartItems_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": CartItem_user$ref;
    readonly " $refType": CartItems_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartItems_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CartItem_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'ecd47b0e1c43946012fbae4e3cfdc770';
export default node;
